import { render } from "./Qichu.vue?vue&type=template&id=3c1553af"
import script from "./Qichu.vue?vue&type=script&lang=js"
export * from "./Qichu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__